export default __webpack_public_path__ + "static/media/heart.c5d58f2c.svg";